import { latencyIcons } from "@/constants/ui/latencyIcons";

export const checkLatencyIcon = (theme: "dark" | "light", latency: number) => {
    switch (true) {
        case latency < 100:
            return latencyIcons[theme].best;
        case latency < 500:
            return latencyIcons[theme].good;
        case latency < 1000:
            return latencyIcons[theme].medium;
        default:
            return latencyIcons[theme].bad;
    }
};
